/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { ProjectAccessGuard } from 'src/app/services/routing/project-access-guard.service';

import { TicketListComponent } from './ticket-list.component';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { ProjectCatalogResolver } from 'src/app/services/routing/project-catalog-resolver.service';
import { TicketListItemComponent } from 'src/app/components/ticket/ticket-list-item/ticket-list-item.component';
import { TicketIndexLogger } from '../services/ticket/ticket-index-logger.service';
import { TicketDetailsModule } from '../ticket-details/ticket-details.module';
import { TicketDetailsComponent } from '../ticket-details/ticket-details/ticket-details.component';
import { TicketDetailResolverService } from './ticket-detail-resolver.service';
import { UserDataResolver } from 'src/app/services/routing/user-data-resolver.service';
import { CustomReuseStrategy } from 'src/app/services/routing/custom-reuse-strategy.service';
import { QueryFactory } from '../services/ticket/query-factory';
import { NoTicketsDisplayComponent } from './no-tickets-display/no-tickets-display.component';
import { mustMigrateToTenantGuard } from 'src/app/common/auth/guards/auth-guards';
import { BannerMessageHandler } from 'src/app/common/logging/banner-message-handler';

const routes: Routes = [
	{
		path: '',
		component: TicketListComponent,
		canActivate: [ProjectAccessGuard, UserDataResolver, mustMigrateToTenantGuard],
		resolve: { projectCatalog: ProjectCatalogResolver, userData: UserDataResolver },
		data: { shouldReuseRoute: true },
		children: [
			{
				path: ':ticketId',
				component: TicketDetailsComponent,
				resolve: { ticket: TicketDetailResolverService },
			},
		],
	},
];

@NgModule({
	declarations: [TicketListComponent, NoTicketsDisplayComponent],
	imports: [
		RouterModule.forChild(routes),
		CommonModule,
		CommonComponentsModule,
		TicketDetailsModule,
		TicketListItemComponent,
	],
	exports: [TicketListComponent],
	providers: [
		AngularFireDatabase,
		ProjectCatalogResolver,
		QueryFactory,
		TicketIndexLogger,
		BannerMessageHandler,
		{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
	],
})
export class TicketListModule {}
